export default "__VITE_ASSET__57dd86f2__"